import { render } from "./recommendedBusiness.vue?vue&type=template&id=105964b6&scoped=true"
import script from "./recommendedBusiness.vue?vue&type=script&lang=js"
export * from "./recommendedBusiness.vue?vue&type=script&lang=js"

import "./recommendedBusiness.vue?vue&type=style&index=0&id=105964b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105964b6"]])

export default __exports__